const tableCols = [
    {
        field: 'RA1_SHIP_TO_ID',
        header: 'Rack ID',
        visible: true,
        filter: true,
        export: {visible: true, checked: true},
        width: 110
    },
    {
        field: 'RA1_SHIP_TO_NAME',
        header: 'Rack Name',
        visible: true,
        filter: true,
        export: {visible: true, checked: true},
        width: 300
    },
    {
        field: 'PL1_SHORT_CODE',
        header: 'Plant Code',
        visible: true,
        filter: true,
        export: {visible: true, checked: true},
        width: 110
    },
    {
        field: 'PL1_NAME',
        header: 'Plant Name',
        visible: true,
        filter: true,
        export: {visible: true, checked: true},
        width: 300
    },
];

export default tableCols;



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/rack/rack.cols.ts